/**
 * Describes the api urls to fetch order related data
 */

const URLS = {
  GET_ORDER: `${process.env.VUE_APP_API_HOST}api/v1/orders/`,
};

export default URLS;
